const cardWrapper = {
  border: 'light',
  borderColor: 'border.base',
  borderRadius: '8',
};

export default {
  Box: {
    baseStyle: {},
    sizes: {},
    variants: {
      cardWrapper: {
        ...cardWrapper,
      },
      tableFilters: {
        p: '8',
        bgColor: 'gray.50',
        borderTopLeftRadius: '8',
        borderTopRightRadius: '8',
        borderBottomEndRadius: '0',
        border: 'light',
        borderColor: 'border.base',
      },
      bodyCardWrapper: {
        border: 'light',
        borderColor: 'border.base',
        borderBottomEndRadius: '8px',
      },
      newton_card: {
        ...cardWrapper,
        p: '8',
      },
      IFTIOutstanding: {
        border: 'medium',
        borderColor: 'border.base',
        borderRadius: 'lg',
      },
      center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    defaultProps: {},
  },
};
